import React, { Fragment, useEffect, useState } from "react";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import moment from "moment";
import exportUrl from "../../../../exportUtl";
import { AgGridReact } from "ag-grid-react";
import {
  attendancerepupload,
  attendancerepuploadlog,
  personaldetupload,
  personaldetuploadlog,
  personaltimeupload,
  personaltimeuploadlog,
  physicalassupload,
  physicalassuploadlog,
  physicalhealthupload,
  physicalhealthuploadlog,
  physicalogicalupload,
  physicalogicaluploadlog,
  schooldetupload,
  schooldetuploadlog,
  sportsactivelist,
} from "../../../../services/superadmin";
import { crmsportslist } from "../../../../services/cityregionaladmin";
import { coachsportslist } from "../../../../services/coach";
import {
  sportslist,
  sportwisetypeparameterlist,
} from "../../../../services/master";
import { toast } from "react-toastify";
import Select from "react-select";

export const Uploadetails = () => {
  const [trecord, setTRecord] = useState(0);
  const [irecord, setIRecord] = useState(0);
  const [urecord, setURecord] = useState(0);
  const [strecord, setStatus] = useState("");
  const [failid, setFailId] = useState(0);
  const [basefile, setBase] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [fileMsg, setFileMsg] = useState("");
  const [filterProduct, setFilterProduct] = useState([]);
  const [s3path, setS3Path] = useState("");
  const [urllink, setUrlLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [usport, setUSport] = useState("");
  const [slist, setSList] = useState([]);

  const columnDefs = [
    {
      headerName: "Upload Excel",
      width: 170,
      field: "uploaded_excel_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              className="excelfailed text-success"
              href={s3path + params.value}
              download={s3path + params.value}
              target="_blank"
              onClick={() =>
                dotracking(
                  "click to download link in player profile for upload personal details in " +
                    " file " +
                    params.value +
                    " (" +
                    params.data.id +
                    ") $$ " +
                    trackobj.assessmentheading
                )
              }
            >
              Click to Download
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Failed Excel",
      width: 150,
      field: "id",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              className="excelfailed text-danger"
              onClick={() => failedent(params.value)}
            >
              Click to Download
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Uploaded on",
      width: 150,
      field: "created_at",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          const adjustedTime = moment(params.value)
            .add(5, "hours")
            .add(30, "minutes");
          return adjustedTime.format("DD-MM-yyyy HH:mm:ss A");
        }
      },
    },
    {
      headerName: "Uploaded by",
      width: 150,
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];
  useEffect(() => {
    const url = window.location.href;
    const head = url.split("/#/");
    const link = head[1].split("/");
    setUrlLink(link[1]);
    setErrorMsg("");
    setFileMsg("");
    setTRecord(0);
    setIRecord(0);
    setURecord(0);
    setStatus("");
    setFailId(0);
    setFilterProduct([]);
    setS3Path("");
    listall(link[1]);

    if (localStorage.getItem("Role") === "1") {
      sportsactivelist().then((response) => {
        if (response.status === true) {
          setSList(response.data);
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
      crmsportslist().then((response) => {
        if (response.status === true) {
          setSList(response.data);
        }
      });
    } else if (localStorage.getItem("Role") === "4") {
      sportslist().then((response) => {
        if (response.status === true) {
          setSList(response.data);
        }
      });
    } else if (localStorage.getItem("Role") === "7") {
      coachsportslist().then((response) => {
        if (response.status === true) {
          setSList(response.data);
        }
      });
    }
  }, [window.location.href]);
  function datafile(event) {
    setFileMsg("");
    setBase("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(xls|xlsx)$/i)) {
        setBase(event.target.files[0]);
      } else {
        setFileMsg("Upload File should be xls or xlsx format");
      }
      // var size = event.target.files[0].size / 1024 / 1024;
      // if (size > 5) {
      //   setErrorMsg("Base Data File size should be less than 5MB");
      // }
    }
  }
  function failedent(fid) {
    if (urllink === "personaldetails") {
      dotracking(
        " failed click to download link button in player profile for upload personal details in " +
          " file failed (" +
          fid +
          ") $$ " +
          trackobj.assessmentheading
      );
      window.open(
        exportUrl + "export-failed-personal-details/" + fid,
        "_blank"
      );
    } else if (
      urllink === "schooldetails" ||
      urllink === "uploadschooldetails"
    ) {
      dotracking(
        " failed click to download link button in player profile for upload school details in " +
          " file failed (" +
          fid +
          ") $$ " +
          trackobj.assessmentheading
      );
      window.open(exportUrl + "export-failed-school-details/" + fid, "_blank");
    } else if (urllink === "personaltimings") {
      dotracking(
        " failed click to download link button in player profile for upload personal timings in " +
          " file failed (" +
          fid +
          ") $$ " +
          trackobj.assessmentheading
      );
      window.open(
        exportUrl + "export-failed-personal-timings/" + fid,
        "_blank"
      );
    } else if (urllink === "attendancedetails") {
      dotracking(
        " failed click to download link button in player profile for upload attendane report in " +
          " file failed (" +
          fid +
          ") $$ " +
          trackobj.assessmentheading
      );
      window.open(
        exportUrl + "export-failed-attendance-report/" + fid,
        "_blank"
      );
    } else if (urllink === "physicalhealth") {
      dotracking(
        " failed click to download link button in player profile for upload physical health in " +
          " file failed (" +
          fid +
          ") $$ " +
          trackobj.assessmentheading
      );
      window.open(
        exportUrl + "export-failed-physical-health-data/" + fid,
        "_blank"
      );
    } else if (urllink === "psychological") {
      dotracking(
        " failed click to download link button in player profile for upload psychological & behavioral profile in " +
          " file failed (" +
          fid +
          ") $$ " +
          trackobj.assessmentheading
      );
      window.open(
        exportUrl + "export-failed-psychological-behavioral-profile/" + fid,
        "_blank"
      );
    } else if (urllink === "physicalassessment") {
      dotracking(
        " failed click to download link button in player profile for upload phusical assessment in " +
          " file failed (" +
          fid +
          ") $$ " +
          trackobj.assessmentheading
      );
      window.open(
        exportUrl + "export-failed-physical-assessment/" + fid,
        "_blank"
      );
    }
  }

  function listall(ltype) {
    setFilterProduct([]);
    if (ltype === "personaldetails") {
      personaldetuploadlog().then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.details);
          setS3Path(res.data.s3path);
        }
      });
    } else if (ltype === "schooldetails" || ltype === "uploadschooldetails") {
      schooldetuploadlog().then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.details);
          setS3Path(res.data.s3path);
        }
      });
    } else if (ltype === "personaltimings") {
      personaltimeuploadlog().then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.details);
          setS3Path(res.data.s3path);
        }
      });
    } else if (ltype === "attendancedetails") {
      attendancerepuploadlog().then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.details);
          setS3Path(res.data.s3path);
        }
      });
    } else if (ltype === "physicalhealth") {
      physicalhealthuploadlog().then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.details);
          setS3Path(res.data.s3path);
        }
      });
    } else if (ltype === "psychological") {
      physicalogicaluploadlog().then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.details);
          setS3Path(res.data.s3path);
        }
      });
    } else if (ltype === "physicalassessment") {
      physicalassuploadlog().then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data.details);
          setS3Path(res.data.s3path);
        }
      });
    }
  }
  function baseupload() {
    setErrorMsg("");
    if (basefile !== "") {
      if (fileMsg === "") {
        setLoading(true);

        if (urllink === "personaldetails") {
          dotracking(
            "submit button in player profile for upload personal details $$ " +
              trackobj.assessmentheading
          );
          const temp = new FormData();
          temp.append("admin_id", localStorage.getItem("UID"));
          temp.append("personal_details_upload_excel", basefile);
          personaldetupload(temp).then((res) => {
            if (res.status === true) {
              setBase("");
              setLoading(false);
              if (res.data.total_rows !== "") {
                setTRecord(res.data.total_rows);
              }
              if (res.data.inserted_count !== "") {
                setIRecord(res.data.inserted_count);
              }
              if (res.data.failed_count !== "") {
                setURecord(res.data.failed_count);
              }
              setFailId(res.data.uploaded_excel_id);
              setStatus(res.data.status);
              listall(urllink);
            }
          });
        } else if (
          urllink === "schooldetails" ||
          urllink === "uploadschooldetails"
        ) {
          dotracking(
            "submit button in player profile for upload school details $$ " +
              trackobj.assessmentheading
          );
          const temp = new FormData();
          temp.append("admin_id", localStorage.getItem("UID"));
          temp.append("school_details_upload_excel", basefile);
          schooldetupload(temp).then((res) => {
            if (res.status === true) {
              setBase("");
              setLoading(false);
              if (res.data.total_rows !== "") {
                setTRecord(res.data.total_rows);
              }
              if (res.data.inserted_count !== "") {
                setIRecord(res.data.inserted_count);
              }
              if (res.data.failed_count !== "") {
                setURecord(res.data.failed_count);
              }
              setFailId(res.data.uploaded_excel_id);
              setStatus(res.data.status);
              listall(urllink);
            }
          });
        } else if (urllink === "personaltimings") {
          dotracking(
            "submit button in player profile for upload personal timings $$ " +
              trackobj.assessmentheading
          );
          const temp = new FormData();
          temp.append("admin_id", localStorage.getItem("UID"));
          temp.append("personal_timings_upload_excel", basefile);
          personaltimeupload(temp).then((res) => {
            if (res.status === true) {
              setBase("");
              setLoading(false);
              if (res.data.total_rows !== "") {
                setTRecord(res.data.total_rows);
              }
              if (res.data.inserted_count !== "") {
                setIRecord(res.data.inserted_count);
              }
              if (res.data.failed_count !== "") {
                setURecord(res.data.failed_count);
              }
              setFailId(res.data.uploaded_excel_id);
              setStatus(res.data.status);
              listall(urllink);
            }
          });
        } else if (urllink === "attendancedetails") {
          dotracking(
            "submit button in player profile for upload attendance report $$ " +
              trackobj.assessmentheading
          );
          const temp = new FormData();
          temp.append("admin_id", localStorage.getItem("UID"));
          temp.append("attendance_report_upload_excel", basefile);
          attendancerepupload(temp).then((res) => {
            if (res.status === true) {
              setBase("");
              setLoading(false);
              if (res.data.total_rows !== "") {
                setTRecord(res.data.total_rows);
              }
              if (res.data.inserted_count !== "") {
                setIRecord(res.data.inserted_count);
              }
              if (res.data.failed_count !== "") {
                setURecord(res.data.failed_count);
              }
              setFailId(res.data.uploaded_excel_id);
              setStatus(res.data.status);
              listall(urllink);
            }
          });
        } else if (urllink === "physicalhealth") {
          dotracking(
            "submit button in player profile for upload physical health $$ " +
              trackobj.assessmentheading
          );
          const temp = new FormData();
          temp.append("admin_id", localStorage.getItem("UID"));
          temp.append("physical_health_data_upload_excel", basefile);
          physicalhealthupload(temp).then((res) => {
            if (res.status === true) {
              setBase("");
              setLoading(false);
              if (res.data.total_rows !== "") {
                setTRecord(res.data.total_rows);
              }
              if (res.data.inserted_count !== "") {
                setIRecord(res.data.inserted_count);
              }
              if (res.data.failed_count !== "") {
                setURecord(res.data.failed_count);
              }
              setFailId(res.data.uploaded_excel_id);
              setStatus(res.data.status);
              listall(urllink);
            }
          });
        } else if (urllink === "psychological") {
          dotracking(
            "submit button in player profile for upload psychological & behavioral profile $$ " +
              trackobj.assessmentheading
          );
          const temp = new FormData();
          temp.append("admin_id", localStorage.getItem("UID"));
          temp.append("psychological_behavioral_upload_excel", basefile);
          physicalogicalupload(temp).then((res) => {
            if (res.status === true) {
              setBase("");
              setLoading(false);
              if (res.data.total_rows !== "") {
                setTRecord(res.data.total_rows);
              }
              if (res.data.inserted_count !== "") {
                setIRecord(res.data.inserted_count);
              }
              if (res.data.failed_count !== "") {
                setURecord(res.data.failed_count);
              }
              setFailId(res.data.uploaded_excel_id);
              setStatus(res.data.status);
              listall(urllink);
            }
          });
        } else if (urllink === "physicalassessment") {
          if (usport !== "") {
            dotracking(
              "submit button in player profile for upload physical assessment $$ " +
                trackobj.assessmentheading
            );
            const temp = new FormData();
            temp.append("admin_id", localStorage.getItem("UID"));
            temp.append("sports_id", usport);
            temp.append("parameter_type_id", asstype ? asstype.value : "");
            temp.append("physical_assessment_upload_excel", basefile);
            physicalassupload(temp).then((res) => {
              if (res.status === true) {
                setBase("");
                setLoading(false);
                if (res.data.total_rows !== "") {
                  setTRecord(res.data.total_rows);
                }
                if (res.data.inserted_count !== "") {
                  setIRecord(res.data.inserted_count);
                }
                if (res.data.failed_count !== "") {
                  setURecord(res.data.failed_count);
                }
                setFailId(res.data.uploaded_excel_id);
                setStatus(res.data.status);
                listall(urllink);
              }
            });
          } else {
            toast.error("Please Select Sport");
          }
        }
      }
    } else {
      if (urllink === "personaldetails") {
        setErrorMsg("Please Upload Personal Details File");
      } else if (
        urllink === "schooldetails" ||
        urllink === "uploadschooldetails"
      ) {
        setErrorMsg("Please Upload School Details File");
      } else if (urllink === "personaltimings") {
        setErrorMsg("Please Upload Personal Timings File");
      } else if (urllink === "attendancedetails") {
        setErrorMsg("Please Upload Attendance Details File");
      } else if (urllink === "physicalhealth") {
        setErrorMsg("Please Upload Physical & Health File");
      } else if (urllink === "psychological") {
        setErrorMsg("Please Upload Psychological & Behavioral profile File");
      } else if (urllink === "physicalassessment") {
        setErrorMsg("Please Upload Physical Assessment File");
      }
    }
  }

  function downloadexcel() {
    if (usport !== "") {
      dotracking(
        "sample excel button in upload player profile entry for physical assessment $$ " +
          trackobj.assessmentheading
      );
      const aid = asstype != "" ? asstype.value : 0;
      // const iurl = exportUrl + "generate-sample-excel/" + usport;
      const iurl = exportUrl + "generate-sample-excel/" + usport + "/" + aid;

      const link = document.createElement("a");
      link.setAttribute("target", "_blank");
      link.setAttribute("href", iurl);
      link.download = iurl;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      toast.error("Please Select Sport");
    }
  }
  const [asstype, setAssType] = useState("");
  const [tlist, setTList] = useState([]);
  function listsport(e) {
    setUSport(e.target.value);
    setAssType("");
    setTList([]);
    if (e.target.value !== null) {
      sportwisetypeparameterlist(e.target.value).then((response) => {
        if (response.status === true) {
          if (response.data.sportsParameters.length !== 0) {
            let arr = [];
            for (let i = 0; i < response.data.sportsParameters.length; i++) {
              arr.push({
                label: response.data.sportsParameters[i].parameter_type,
                value: response.data.sportsParameters[i].id,
              });
            }
            setTList(arr);
          }
        }
      });
    }
  }

  function handleType(e) {
    if (e !== null) {
      setAssType(e);
    } else {
      setAssType("");
    }
  }
  return (
    <Fragment>
      <div className="side-app">
        <div className="page-header">
          <div className="breadcrumb">
            {urllink === "personaldetails" && (
              <h4 className="mb-0">Upload Personal Details</h4>
            )}
            {(urllink === "schooldetails" ||
              urllink === "uploadschooldetails") && (
              <h4 className="mb-0">Upload School Details</h4>
            )}
            {urllink === "personaltimings" && (
              <h4 className="mb-0">Upload Personal Timings</h4>
            )}
            {urllink === "attendancedetails" && (
              <h4 className="mb-0">Upload Attendance Details</h4>
            )}
            {urllink === "physicalhealth" && (
              <h4 className="mb-0">Upload Physical & Health</h4>
            )}
            {urllink === "psychological" && (
              <h4 className="mb-0">
                Upload Psychological & Behavioral Profile
              </h4>
            )}
            {urllink === "physicalassessment" && (
              <h4 className="mb-0">Upload Physical Assessment</h4>
            )}
          </div>

          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Student Assessment</a>
            </li>
            {urllink === "personaldetails" && (
              <li className="breadcrumb-item active" aria-current="page">
                Personal Details
              </li>
            )}
            {(urllink === "schooldetails" ||
              urllink === "uploadschooldetails") && (
              <li className="breadcrumb-item active" aria-current="page">
                School Details
              </li>
            )}
            {urllink === "personaltimings" && (
              <li className="breadcrumb-item active" aria-current="page">
                Personal Timings
              </li>
            )}
            {urllink === "attendancedetails" && (
              <li className="breadcrumb-item active" aria-current="page">
                Attendance Details
              </li>
            )}
            {urllink === "physicalhealth" && (
              <li className="breadcrumb-item active" aria-current="page">
                Physical & Health
              </li>
            )}
            {urllink === "psychological" && (
              <li className="breadcrumb-item active" aria-current="page">
                Psychological & Behavioral Profile
              </li>
            )}
            {urllink === "physicalassessment" && (
              <li className="breadcrumb-item active" aria-current="page">
                Physical Assessment
              </li>
            )}
          </ol>
        </div>

        {loading && (
          <div className="dashloader-wrapper">
            <div className="loader"></div>
            <h3>Loading...Please do not go back or close the window.</h3>
          </div>
        )}

        {!loading && (
          <>
            <div className="row">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body">
                    <div className="form-group">
                      {urllink === "personaldetails" && (
                        <label className="form-label">
                          Upload Personal Details File{" "}
                          <span className="errortext"> *</span>
                        </label>
                      )}
                      {(urllink === "schooldetails" ||
                        urllink === "uploadschooldetails") && (
                        <label className="form-label">
                          Upload School Details File{" "}
                          <span className="errortext"> *</span>
                        </label>
                      )}
                      {urllink === "personaltimings" && (
                        <label className="form-label">
                          Upload Personal Timings File{" "}
                          <span className="errortext"> *</span>
                        </label>
                      )}
                      {urllink === "attendancedetails" && (
                        <label className="form-label">
                          Upload Attendance Details File{" "}
                          <span className="errortext"> *</span>
                        </label>
                      )}
                      {urllink === "physicalhealth" && (
                        <label className="form-label">
                          Upload Physical & Health File{" "}
                          <span className="errortext"> *</span>
                        </label>
                      )}
                      {urllink === "psychological" && (
                        <label className="form-label">
                          Upload Psychological & Behavioral Profile File{" "}
                          <span className="errortext"> *</span>
                        </label>
                      )}
                      {urllink === "physicalassessment" && (
                        <label className="form-label">
                          Upload Physical Assessment File{" "}
                          <span className="errortext"> *</span>
                        </label>
                      )}
                      {urllink === "physicalassessment" && (
                        <>
                          <div className="form-group">
                            <label className="form-label">
                              Sports <span className="errortext"> *</span>
                            </label>
                            <select
                              className="form-control custom-select"
                              value={usport}
                              onChange={(e) => listsport(e)}
                            >
                              <option value="" defaultValue disabled>
                                --Select Sports--
                              </option>
                              {slist.map((item, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={item.sports_cat_uid}
                                  >
                                    {item.sports_category}
                                  </option>
                                );
                              })}
                            </select>
                          </div>

                          <div className="form-group">
                            <label className="form-label">
                              Parameter Type{" "}
                              <span className="errortext"> *</span>
                            </label>
                            <Select
                              className="dropdown"
                              placeholder="Select Parameter Type"
                              value={asstype}
                              options={tlist}
                              onChange={handleType}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                          </div>
                          <div className="form-group">
                            <small className="text-muted">
                              Excel must include column{" "}
                              <strong>Assessment Type</strong> with values:{" "}
                              general, baseline, or endline.
                            </small>
                          </div>
                        </>
                      )}

                      <input
                        type="file"
                        className="form-control"
                        accept=".xlsx,.xls"
                        onChange={datafile}
                      />
                    </div>
                    {errorMsg !== "" && (
                      <span className="errortext">{errorMsg}</span>
                    )}
                    <hr />
                    <div className="form-group">
                      <a className="btn btn-success me-2" onClick={baseupload}>
                        Submit
                      </a>
                      {urllink === "personaldetails" && (
                        <a
                          className="btn btn-secondary"
                          href={require("../../../../assets/images/Personal_Details.xlsx")}
                          download
                          onClick={() => {
                            dotracking(
                              "sample excel button in upload player profile entry for personal detail $$ " +
                                trackobj.assessmentheading
                            );
                          }}
                        >
                          Sample Excel
                        </a>
                      )}
                      {(urllink === "schooldetails" ||
                        urllink === "uploadschooldetails") && (
                        <a
                          className="btn btn-secondary"
                          href={require("../../../../assets/images/School_Details.xlsx")}
                          download
                          onClick={() => {
                            dotracking(
                              "sample excel button in upload player profile entry for school detail $$ " +
                                trackobj.assessmentheading
                            );
                          }}
                        >
                          Sample Excel
                        </a>
                      )}
                      {urllink === "personaltimings" && (
                        <a
                          className="btn btn-secondary"
                          href={require("../../../../assets/images/Personal_Timings.xlsx")}
                          download
                          onClick={() => {
                            dotracking(
                              "sample excel button in upload player profile entry for personal timings $$ " +
                                trackobj.assessmentheading
                            );
                          }}
                        >
                          Sample Excel
                        </a>
                      )}
                      {urllink === "attendancedetails" && (
                        <a
                          className="btn btn-secondary"
                          href={require("../../../../assets/images/Attandance.xlsx")}
                          download
                          onClick={() => {
                            dotracking(
                              "sample excel button in upload player profile entry for attendance $$ " +
                                trackobj.assessmentheading
                            );
                          }}
                        >
                          Sample Excel
                        </a>
                      )}
                      {urllink === "physicalhealth" && (
                        <a
                          className="btn btn-secondary"
                          href={require("../../../../assets/images/Physical_Health_Data.xlsx")}
                          download
                          onClick={() => {
                            dotracking(
                              "sample excel button in upload player profile entry for physical health $$ " +
                                trackobj.assessmentheading
                            );
                          }}
                        >
                          Sample Excel
                        </a>
                      )}
                      {urllink === "psychological" && (
                        <a
                          className="btn btn-secondary"
                          href={require("../../../../assets/images/Psychological_Behavioral_Profile.xlsx")}
                          download
                          onClick={() => {
                            dotracking(
                              "sample excel button in upload player profile entry for psychological & behavioral profile $$ " +
                                trackobj.assessmentheading
                            );
                          }}
                        >
                          Sample Excel
                        </a>
                      )}
                      {urllink === "physicalassessment" && (
                        <a
                          className="btn btn-secondary"
                          onClick={downloadexcel}
                        >
                          Sample Excel
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div
                  className="ag-theme-alpine ag-style"
                  style={{
                    height: 320,
                  }}
                >
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="4"
                    sortingOrder={["asc,desc"]}
                    suppressExcelExport={true}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>
            </div>

            <div className="row row-cards mt-3">
              <div className="">
                <h4>Upload Summary</h4>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                <div className="card bg-custom">
                  <div className="card-body text-center feature">
                    <p className="card-text mt-3 mb-3">
                      <strong>Total Records</strong>
                    </p>
                    <p className="h3 text-center text-info">{trecord}</p>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                <div className="card bg-custom">
                  <div className="card-body text-center feature">
                    <p className="card-text mt-3 mb-3">
                      <strong>Inserted Records</strong>
                    </p>
                    <p className="h3 text-center text-primary-1">{irecord}</p>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                <div className="card bg-custom">
                  <div className="card-body text-center feature">
                    <p className="card-text mt-3 mb-3">
                      <strong>Failed Records</strong>
                    </p>
                    <p className="h3 text-center text-teal">{urecord}</p>
                    {urecord !== 0 && (
                      <a
                        className="excelfailed text-danger"
                        onClick={() => failedent(failid)}
                      >
                        <b>Click to Download</b>
                      </a>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                <div className="card bg-custom">
                  <div className="card-body text-center feature">
                    <p className="card-text mt-3 mb-3">
                      <strong>Upload Status</strong>
                    </p>
                    {strecord === "Success" && (
                      <p className="h2 badge badge-success">
                        <b>{strecord}</b>
                      </p>
                    )}
                    {strecord !== "Success" && (
                      <p className="h2 badge badge-danger">
                        <b>{strecord}</b>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </Fragment>
  );
};
